export const CONSTANTS = {
  languages: [`en`, `fi`, `es`],
  mainMenuItems: ['events', 'artists', 'venues', 'about'],
  mobile: '1100px',
};
